<template>
  <div class="page-scroll-container" ref="pageContainer" id="page8-container">
    <!-- 1. [底层] 清晰背景图 (始终可见，作为底色) -->
    <img
      class="bg-layer clear-bg"
      src="../../../assets/annualReport/page8_choice_bac.png"
      alt="bg-clear"
    />

    <!-- 2. [中间层] 预渲染的模糊/变暗背景图 (控制 Opacity 实现渐变) -->
    <img
      class="bg-layer blur-bg"
      :class="{ active: isVisible }"
      src="../../../assets/annualReport/page8_blur.png"
      alt="bg-blur"
    />

    <!-- 3. [顶层] 核心卡片 -->
    <div class="visual-card" :class="{ 'start-anim': isVisible }">
      <!-- 卡片内部背景 -->
      <div class="card-bg-container">
        <img
          class="card-img"
          src="../../../assets/annualReport/page8_choice_bac.png"
          alt="card-bg"
        />
      </div>

      <!-- 主文案 -->
      <div class="message">
        <div>当别人看比赛</div>
        <div>还在问“喝什么？”</div>
        <div>您早已将<span class="cup-sleeve">库迪合作杯套</span></div>
        <div>甩在桌面，漫不经心的</div>
        <div>指向最醒目的四个大字</div>
      </div>

      <!-- 官方指定 -->
      <div class="official-message">
        <div class="official">
          <span>[</span>
          <span>官</span>
          <span>方</span>
          <span>指</span>
          <span>定</span>
          <span>]</span>
        </div>
        <div class="card-face">这一杯 够排面</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "page8Choice",
  data() {
    return {
      isVisible: false,
      observer: null,
    };
  },
  mounted() {
    document.body.classList.add("lock-scroll");
    const vm = this;

    vm.observer = new IntersectionObserver(
      function (entries) {
        const entry = entries[0];

        if (entry.isIntersecting) {
          console.log("Page8 进入视野");
          vm.isVisible = true;
        } else {
          console.log("Page8 离开视野");
          vm.isVisible = false;
        }
      },
      { threshold: 0.2 } // 降低阈值，确保更容易触发
    );

    if (vm.$refs.pageContainer) {
      vm.observer.observe(vm.$refs.pageContainer);
    }
  },

  beforeDestroy() {
    document.body.classList.remove("lock-scroll");
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  },
};
</script>

<style lang="scss" scoped>
/* =========================================
   1. 外层容器与背景层控制
   ========================================= */
.page-scroll-container {
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #1a1a1a;
}

/* 背景层通用样式 */
.bg-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  object-fit: cover;
}

/* 底层：清晰图 */
.clear-bg {
  z-index: 0;
}

/* 中间层：模糊图 */
.blur-bg {
  z-index: 1;
  opacity: 0;
  transition: opacity 1.2s ease-in-out;
  will-change: opacity;
  transform: translateZ(0);

  &.active {
    opacity: 1;
  }
}

/* =========================================
   2. 核心卡片 (适配逻辑统一)
   ========================================= */
.visual-card {
  position: relative;
  z-index: 2;

  /* --- 默认状态：适应主流手机 --- */
  width: 100vw;
  height: 100vh;

  container-type: size;
  isolation: isolate;
  --unit: 1vw;
}

/* 卡片内部的背景容器 */
.card-bg-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
  transform: translateZ(0);
  backface-visibility: hidden;
}

.card-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: fill;
}

/* --- 情况 A: 屏幕太宽 (平板/PC) --- */
@media (min-aspect-ratio: 13/25) {
  .visual-card {
    height: 100vh;
    width: calc(100vh * 390 / 844);
    aspect-ratio: 390 / 844;
    --unit: 0.462vh;
  }
}

/* --- 情况 B: 屏幕太长 (带鱼屏) --- */
@media (max-aspect-ratio: 9/21) {
  .visual-card {
    width: 100vw;
    height: calc(100vw * 844 / 390);
    aspect-ratio: 390 / 844;
    --unit: 1vw;
  }
}

/* =========================================
   3. 元素样式 & 布局修正
   ========================================= */

.message {
  position: absolute;
  top: 56.5%;
  left: 8%;
  width: 48%;
  height: auto;

  display: flex;
  flex-direction: column;
  gap: calc(2.4 * var(--unit));

  color: #5b2a15;
  font-weight: 600;
  font-size: calc(4.2 * var(--unit));

  .cup-sleeve {
    color: #c45808;
  }

  > div {
    opacity: 0;
  }
}

.official-message {
  position: absolute;
  bottom: 12%;
  right: 6.5%;
  width: auto;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: calc(2.2 * var(--unit));
  color: #5b2a15;
  font-weight: 600;
  font-size: calc(4 * var(--unit));
  align-items: flex-end;

  .official {
    font-weight: 600;
    color: #c45808;
    font-size: calc(7.2 * var(--unit));
    display: flex;
    justify-content: flex-end;

    span {
      display: inline-block;
      opacity: 0;
      white-space: pre;
    }
  }

  .card-face {
    letter-spacing: calc(0.7 * var(--unit));
    opacity: 0;
    color: #5b2a15;
  }
}

/* =========================================
   4. 动画控制逻辑
   ========================================= */

.start-anim {
  /* 第1批：前两行 */
  .message > div:nth-child(-n + 2) {
    animation: textFloatUp 1s ease-out forwards;
    animation-delay: 0.3s;
  }

  /* 第2批：后三行 */
  .message > div:nth-child(n + 3) {
    animation: textFloatUp 1s ease-out forwards;
    animation-delay: 1.2s;
  }

  /* 第3批：[官方指定] 逐个跳出 */
  .official-message .official span {
    animation: jumpPop 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
  }

  @for $i from 1 through 6 {
    .official-message .official span:nth-child(#{$i}) {
      animation-delay: #{2 + ($i - 1) * 0.1}s;
    }
  }

  /* 第4批：这一杯 够排面 */
  .official-message .card-face {
    animation: textFloatUp 1s ease-out forwards;
    animation-delay: 2.8s;
  }
}

/* =========================================
   5. 关键帧定义
   ========================================= */

@keyframes textFloatUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes jumpPop {
  0% {
    opacity: 0;
    transform: translateY(50%) scale(0);
  }
  60% {
    opacity: 1;
    transform: translateY(-15%) scale(1.2);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
</style>
